<div class="main-container" style="padding: 10px">
  <div class="btn-group btn-icon">
    @if (userCanEdit) {
      <button class="btn" (click)="neu()">
        <cds-icon [title]="'Neu' | mrTranslate" size="20" shape="file" />
      </button>
      <button class="btn" (click)="save()" [disabled]="this.stage.getLayers().length == 0">
        <cds-icon [title]="'Speichern' | mrTranslate" size="20" shape="floppy" />
      </button>
    }
    <button class="btn" (click)="saveAsPDF()" [disabled]="this.stage.getLayers().length == 0">
      <cds-icon [title]="'PDF erstellen' | mrTranslate" size="20" shape="pdffile" />
    </button>
    <button class="btn" (click)="saveAsImage()" [disabled]="this.stage.getLayers().length == 0">
      <cds-icon [title]="'als Bild speichern...' | mrTranslate" size="20" shape="image" />
    </button>

    <button class="btn" (click)="showHistory()">
      <cds-icon [title]="'Historie öffnen' | mrTranslate" size="20" shape="history" />
    </button>

    @if (userCanEdit) {
      <button class="btn" (click)="undo()" [disabled]="!undo_flag">
        <cds-icon [title]="'Zurück' | mrTranslate" size="20" shape="undo" />
      </button>
      <button class="btn" (click)="redo()" [disabled]="!redo_flag">
        <cds-icon [title]="'Wiederholen' | mrTranslate" size="20" shape="redo" />
      </button>
      <button class="btn" (click)="showTemplates()" [disabled]="hasTemplate">
        <cds-icon [title]="'Vorlage öffnen' | mrTranslate" size="20" shape="library" />
      </button>
      <button class="btn" (click)="line()">
        <cds-icon [title]="'Linie' | mrTranslate" size="20" shape="drawline" />
      </button>
      <button class="btn" (click)="freeline()">
        <cds-icon [title]="'Stift' | mrTranslate" size="20" shape="drawfree" />
      </button>
      <button class="btn" (click)="rectangle()">
        <cds-icon [title]="'Rechteck' | mrTranslate" size="20" shape="drawrect" />
      </button>
      <button class="btn" (click)="arc()">
        <cds-icon [title]="'Kurve' | mrTranslate" size="20" shape="drawarc" />
      </button>
      <button class="btn" (click)="point()">
        <cds-icon [title]="'Punkt' | mrTranslate" size="20" shape="drawpoint" />
      </button>
      <button class="btn" (click)="circle()">
        <cds-icon [title]="'Kreis' | mrTranslate" size="20" shape="circle" />
      </button>
      <button class="btn">
        <cds-icon
          shape="circle"
          solid="true"
          class="cursor-pointer"
          [ngStyle]="{ color: curcolor }"
          [(colorPicker)]="curcolor"
          (colorPickerChange)="onColorChange($event)" />
      </button>
      <clr-number-input-container class="margin-6-t margin-6-l">
        <input
          clrNumberInput
          type="number"
          [(ngModel)]="curstrokeWidth"
          [ngModelOptions]="{ standalone: true }"
          min="3"
          max="10"
          (input)="onSizeChange($event.target.value)"
          (blur)="strokeChanged($event.target.value)" />
      </clr-number-input-container>
    }
  </div>

  @if (sidebarShow) {
    <div class="sidebar-slider">
      <div class="sidebar-close" (click)="sidebarShow = false">X</div>
      <div class="sidebar-content">
        <h2 style="color: white">{{ 'Vorlagen' | mrTranslate }}</h2>
        @for (icon of sideBarIcons; track icon) {
          <div>
            <img
              [src]="getImageSaveUrl(icon.base64String)"
              (click)="addTemplate(icon.name, icon.base64String)"
              draggable="false"
              class="cursor-pointer skizze invert" />
          </div>
        }
        <button class="btn btn-outline" (click)="fileInput.click()">
          <cds-icon size="20" shape="plus" />
          {{ 'Vorlage hinzufügen' | mrTranslate }}
        </button>
        <input
          type="file"
          #fileInput
          id="fileInput"
          name="fileInput"
          accept=".png"
          hidden
          (change)="onFileChange($event.target.files)" />
      </div>
    </div>
  }

  @if (historieShow) {
    <div class="sidebar-slider">
      <div class="sidebar-close" (click)="historieShow = false">X</div>
      <h2 style="margin-left: 20px">{{ 'Historie' | mrTranslate }}</h2>
      <clr-tree>
        <clr-tree-node [clrExpanded]="true">
          <cds-icon size="20" shape="folder" />
          {{ 'Allgemein' | mrTranslate }}
          @for (row of historyAllgemein; track row) {
            <clr-tree-node>
              <button (click)="openHistory(row)" class="clr-treenode-link" [class.active]="row.active">
                {{ row.Status }}
              </button>
            </clr-tree-node>
          }
        </clr-tree-node>
        <clr-tree-node>
          <cds-icon size="20" shape="folder" />
          {{ 'Auftrag' | mrTranslate }}
          @for (row of historyAuftrag; track row) {
            <clr-tree-node>
              <button (click)="openHistory(row)" class="clr-treenode-link" [class.active]="row.active">
                {{ row.Status }}
              </button>
            </clr-tree-node>
          }
        </clr-tree-node>
        <clr-tree-node>
          <cds-icon size="20" shape="folder" />
          {{ 'Rückmeldung' | mrTranslate }}
          @for (row of historyRueckmeldung; track row) {
            <clr-tree-node>
              <button (click)="openHistory(row)" class="clr-treenode-link" [class.active]="row.active">
                {{ row.Status }}
              </button>
            </clr-tree-node>
          }
        </clr-tree-node>
      </clr-tree>
    </div>
  }

  <div class="clr-row nxm">
    <div [ngClass]="stage.getLayers().length != 0 ? 'clr-col-9' : 'clr-col-12'" class="margin-10-t">
      <div class="paint">
        <div style="background-color: white" id="drawing-field" (click)="draw_shape()"></div>
      </div>
    </div>

    @if (stage.getLayers().length != 0) {
      <div class="clr-col-3 margin-10-t">
        <clr-stack-view>
          <clr-stack-block [clrStackViewLevel]="1" [clrSbExpanded]="true">
            <clr-stack-label>{{ 'Objekte' | mrTranslate }}</clr-stack-label>
            @for (layer of stage.getLayers() | paintfilterlayer: findNonTempLayer; track layer; let j = $index) {
              <clr-stack-block [clrStackViewLevel]="2">
                <clr-stack-label>
                  @if (!layer.attrs.isTemplate && userCanEdit) {
                    <div>
                      <div class="clr-input-wrapper" style="margin-top: -25px">
                        <input
                          clrInput
                          placeholder="{{ layer.attrs.name }}"
                          name="name"
                          [(ngModel)]="layer.attrs.name"
                          style="min-width: 150px"
                          (focusout)="focusOut(layer)"
                          (focus)="focusIn(layer)" />
                      </div>
                    </div>
                  } @else {
                    {{ layer.attrs.name | mrTranslate }}
                  }
                </clr-stack-label>
                @if (!layer.attrs.isTemplate && userCanEdit) {
                  <div>
                    <clr-stack-content>
                      <div class="btn-group btn-icon btn-sm">
                        <button class="btn" (click)="doSelect(layer)">
                          <cds-icon [title]="'Bearbeiten' | mrTranslate" size="20" shape="pencil" />
                        </button>
                        <button class="btn" (click)="doDelete(layer)">
                          <cds-icon [title]="'Löschen' | mrTranslate" size="20" shape="trash" />
                        </button>
                        <button class="btn" (click)="doEndEdit(layer)" [disabled]="!layer.attrs.edit">
                          <cds-icon [title]="'Bearbeiten beenden' | mrTranslate" size="20" shape="success-standard" />
                        </button>
                        <button class="btn" (click)="doCopy(layer)" [disabled]="!layer.attrs.edit">
                          <cds-icon [title]="'Kopieren' | mrTranslate" size="20" shape="copy" />
                        </button>
                      </div>
                    </clr-stack-content>
                  </div>
                }
              </clr-stack-block>
            }
          </clr-stack-block>
        </clr-stack-view>
      </div>
    }
  </div>
</div>
